import { SVGProps } from "react";

function Logo(props: SVGProps<SVGSVGElement>) {
  return (
    <div className="flex items-center gap-0 ml-0 select-none">
      <svg
        width="240"
        height="70" 
        viewBox="0 0 280 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{userSelect: 'none'}}
        onContextMenu={(e) => e.preventDefault()}
      >
        <text
          x="60"
          y="40"
          fontFamily="Nunito, sans-serif"
          fontSize="43"
          fontWeight="700"
          fill="#005f5f"
          style={{userSelect: 'none'}}
        >
          prescrable
        </text>
        <path
          d="M16.4629 23.7156C16.4629 23.7156 16.4629 33.5294 28.7301 33.5294C42.633 33.5294 40.9974 23.7156 40.9974 23.7156"
          stroke="#0BB4B4"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M28.5659 33.5294C28.5659 33.5294 27.4392 40.2596 28.5659 43.1797C31.486 50.7481 41.3238 51.1943 49.3384 43.1797C57.353 35.1651 56.4074 20.9214 49.3384 11.612C40.0289 -0.648052 20.2404 0.190194 9.91966 11.612C-2.3474 25.1877 2.51067 41.6927 13.0276 54.7927C22.3507 66.4057 31.3466 74.0931 31.3466 74.0931"
          stroke="#0BB4B4"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <circle cx="31.6733" cy="75.0745" r="7.19678" fill="#0F686D" />
        <circle cx="31.6745" cy="75.0744" r="4.9069" fill="white" />
        <circle cx="16.5" cy="23.5" r="3.5" fill="#0F686D" />
        <circle cx="41" cy="24" r="4" fill="#0F686D" />
        <text
          x="62"
          y="70"
          fontFamily="Geist, Helvetica, Arial, sans-serif"
          fontSize="20"
          fill="#000"
          style={{userSelect: 'none'}}
        >
          tap. prescribe. share.
        </text>
      </svg>
    </div>
  );
}

export default Logo;